// Packaging.Id — branded packaging identifier.
export { from, mk, to };
import { mkParser } from "../_ids/parse.js";
const mk = (s) => s;
const to = mkParser("PackagingId", mk);
const from = (id) => id;
//# sourceMappingURL=id.js.map